export const isApplicationActivated = ({
  isDraft,
}: {
  isDraft?: boolean | null;
}): boolean => isDraft !== true;
